module.exports = __webpack_public_path__ + "img/icon-pencil.6425dbc4.svg";